import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetUserContactsAction} from '../action';

const tableId = 'userContacts';

function* execute({payload: {tableDataRequest, userProfileId}}: GetUserContactsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getUserContactsPage,
        successAction: adminAction.getUserContactsSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}

/** Runs the admin saga that loads contacts for the selected user. */
export function* getUserContactsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_USER_CONTACTS', execute);
}
